import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { addFavOrder } from '@kfc-global/react-shared/redux/Actions/OrderHistoryAction';

import { isMobileDevice } from '../../../common/utilities/utils';
import ModalComponent from '../../../molecules/Modal';
import { InputBox } from '../../../atoms/InputBox';
import { ButtonComp } from '../../../atoms/Buttons';
import PAYMENT_PROCESS from '../Constants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { useDispatch } from 'react-redux';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import ImageComponent from 'atoms/Image';

export const ModalComp = props => {
  const { isOpen = false, handleClose, onSave, tenantReducer = {}, OrderReducerData = {} } = props;
  const { SPECIAL_CHAR_ERROR, OCCASION_NAME_LENGTH_ERROR, EMPTY_NAME_ERROR, CANCEL, SAVE } = TRANSLATE_MAPPING_KEY;
  const { tenantId = '' } = tenantReducer;
  const { id = '', customer: { id: customerId = '', phoneNumber = '' } = {} } = OrderReducerData;
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const [isButtonDisable, setIsButtonDisable] = useState(true);
  const [saveName, setSaveName] = useState({
    value: '',
    errorMessage: '',
    error: false,
  });
  const { THANKYOU = '', WE_SAVED = '', GIVE_A_NAME = '', FAVORITES_ORDERS_REGEX } = PAYMENT_PROCESS;

  /**
   * Constants for Error handling message display
   * @param {Error parameter} error
   * @returns
   */

  const getSaveNameData = (saveNameObject, inputSaveName) => {
    let saveNameObj = { ...saveNameObject };
    saveNameObj.value = inputSaveName;
    const valid = FAVORITES_ORDERS_REGEX?.test(inputSaveName);
    if (!inputSaveName) {
      saveNameObj.error = true;
      saveNameObj.errorMessage = translateWithI18Next(EMPTY_NAME_ERROR);
      setIsButtonDisable(true);
    } else if (!valid) {
      saveNameObj.error = true;
      saveNameObj.errorMessage = translateWithI18Next(SPECIAL_CHAR_ERROR);
    } else if (inputSaveName.length < 3) {
      saveNameObj.error = true;
      saveNameObj.errorMessage = translateWithI18Next(OCCASION_NAME_LENGTH_ERROR);
      setIsButtonDisable(true);
    } else {
      saveNameObj.error = false;
      saveNameObj.errorMessage = '';
      setIsButtonDisable(false);
    }
    return saveNameObj;
  };

  const getUserData = callBack => {
    callBack();
  };

  const updateUserDetails = event => {
    const inputValue = event.target.value;

    getUserData(() =>
      setSaveName({
        ...getSaveNameData(saveName, inputValue),
      }),
    );
  };

  const dispatch = useDispatch();
  useEffect(() => {
    window.addEventListener('resize', windowResized);
    return () => {
      window.removeEventListener('resize', windowResized);
    };
  });
  const windowResized = () => {
    setIsMobile(isMobileDevice(window.innerWidth));
  };
  const modalProps = isMobile
    ? {
        id: 'OrderSaveModalPopup',
        role: 'dialog',
        modalTitleId: 'OrderSaveModalPopup',
        show: isOpen,
        classNames: 'save-order-modal',
        showCloseBtn: true,
        closeButtonHandler: handleClose,
        autoFocus: true,
      }
    : {
        id: 'OrderSaveModalPopup',
        role: 'dialog',
        modalTitleId: 'OrderSaveModalPopup',
        show: isOpen,
        classNames: 'save-order-modal',
        showCloseBtn: true,
        showBackBtn: false,
        closeButtonHandler: handleClose,
        // backButtonHandler: handleClose,
        autoFocus: true,
      };

  const couponApplyHandler = e => {
    let saveNameObj = { ...saveName };
    e.stopPropagation();
    console.log('saved');

    if (saveName.value !== '') {
      dispatch(
        addFavOrder(
          {
            customerId,
            tenantId,
            phoneNumber,
          },
          {
            orderId: id,
            name: saveName.value,
          },
        ),
      );
      onSave(true);
      handleClose();
    } else {
      saveNameObj.error = true;
      saveNameObj.errorMessage = translateWithI18Next(PAYMENT_PROCESS.SAVE_ORDER_NAME_ERROR);
      setIsButtonDisable(true);
      setSaveName(saveNameObj);
    }
  };

  const oncancel = () => {
    console.log('close');
    handleClose();
  };
  return (
    <div>
      {isOpen && (
        <ModalComponent {...modalProps}>
          <div className='modalContants'>
            <div className='fontstyle'>{translateWithI18Next(THANKYOU)}</div>
            <div className='fontstyle'>{translateWithI18Next(WE_SAVED)}</div>
            <div className='fontstyle'>{translateWithI18Next(GIVE_A_NAME)}</div>
            {!isMobile ? (
              <div className='inputbox trackOrderScreen'>
                <InputBox
                  value={saveName.value}
                  className='inputfield'
                  placeholder='Name This Order'
                  data-testid='modal-coupon-input-field'
                  onChange={updateUserDetails}
                  // onKeyPressHandler={keyPressHandler}
                />
                {saveName.error && (
                  <div id='saveTrackOrderScreen' className='error-text'>
                    <ImageComponent srcFile={IMAGE_PATH.Error} className='location-alert-icon mr-1' />
                    <span className='error-msg' role='alert'>
                      {saveName.errorMessage}
                    </span>
                  </div>
                )}
              </div>
            ) : (
              <div>
                <div className='inputbox'>
                  <InputBox
                    value={saveName.value}
                    className='inputfield'
                    placeholder='Name This Order'
                    data-testid='modal-coupon-input-field'
                    onChange={updateUserDetails}
                    // onKeyPressHandler={keyPressHandler}
                  />
                </div>
                {saveName.error && (
                  <div id='saveTrackOrderScreen' className='error-text'>
                    <ImageComponent srcFile={IMAGE_PATH.Error} className='location-alert-icon mr-1' />
                    <span role='alert'>{saveName.errorMessage}</span>
                  </div>
                )}
              </div>
            )}

            <div className='buttonItems'>
              <ButtonComp
                data-testid='coupon-button-one'
                className='button whiteButton blackBorder closebtn-cls'
                onClick={e => oncancel()}
              >
                {translateWithI18Next(CANCEL)}
              </ButtonComp>
              <ButtonComp
                data-testid='coupon-button-two'
                className='button blackButton blackBorder save-button'
                onClick={e => couponApplyHandler(e)}
                disabled={isButtonDisable}
              >
                {translateWithI18Next(SAVE)}
              </ButtonComp>
            </div>
          </div>
        </ModalComponent>
      )}
    </div>
  );
};

ModalComp.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
};

ModalComp.defaultProps = {
  isOpen: false,
  closeModal: null,
};

export default ModalComp;
